<template>
  <modal
    :disableAction="disableAction"
    :showClose="modalConfig.showClose"
    class="scrollbar"
    :wrapperClasses="modalConfig.wrapperClasses"
    @action="uploadImage(modalConfig.isStoredImage)"
    @close="closeModal(modalConfig.isStoredImage, true)">
    <h3 slot="header" class="title">{{ modalConfig.title }}</h3>
    <p slot="subHeader" v-if="!expandMMS">images containing blatant cannabis verbiage will be blocked by carriers and
      the campaign will not deliver to your members. if your image does contain cannabis verbiage use the "send image as
      link" option.</p>
    <div slot="body" class="image-preview-container">
      <div class="image-preview">
        <loading-icon v-if="imageLoading"></loading-icon>
        <img
          v-show="!imageLoading"
          :alt="alt"
          :class="['image', imageClasses]"
          :src="imageSrc"
          @load="setImageLoading"
          @error="$emit('errorLoadingImage', 'unable to load or resize the image, please try again or use another image')">
        <div v-if="disclaimer" class="disclaimer">
          <p class="disclaimer-preview">
            Disclaimer: {{ disclaimer }}
          </p>
        </div>
      </div>
      <div v-if="suggestedText" class="suggestedTextWrapper setting-wrapper">
        <i class="flaticon-chat-1"></i>
        <div class="suggestedText">
          <p>
            <strong>suggested text</strong><br/><span v-html="suggestedText"></span>
          </p>
        </div>
      </div>
      <div v-if="!!requestedFilters && requestedFilters.length > 0" class="filters-wrapper setting-wrapper">
        <div style="display:flex;align-items:center;">
          <fai :icon="['far', 'list-alt']" class="filter-icon"/>
          <p style="margin-bottom:0"><strong>requested filters</strong></p>
        </div>
        <ul class="request-filters">
          <li v-for="(filter, index) in requestedFilters" :key="index">
            <span>{{ filter.name }}: {{ filter.labels }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div slot="action" class="action-wrapper">
      <button
        v-if="modalConfig.actionButton"
        slot="action"
        class="upload-image button larger"
        :disabled="disableAction"
        @click="uploadImage(modalConfig.isStoredImage)">
        {{ modalConfig.actionButton }}
      </button>

      <button
        v-if="modalConfig.secondaryButton"
        class="upload-image button larger"
        :disabled="disableAction"
        @click="uploadImageAsLink(modalConfig.isStoredImage)"
      >
        {{ modalConfig.secondaryButton }}
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '../shared/Modal'
import LoadingIcon from '../shared/LoadingIcon'

export default {
  props: {
    alt: [String, Array],
    disableAction: {
      default: false,
      type: Boolean
    },
    disclaimer: String,
    expandMMS: Boolean,
    imageClasses: String,
    imageSrc: [String, Array],
    isBackup: Boolean,
    isLink: Boolean,
    modalConfig: Object,
    suggestedText: String,
    requestedFilters: {
      default: () => [],
      type: Array
    }
  },

  name: 'ImagePreviewModal',

  components: {
    LoadingIcon,
    Modal,
  },

  data() {
    return {
      imageLoading: true,
      sendAsLink: false
    }
  },
  methods: {
    closeModal(isStoredImage, isCancel) {
      this.$emit('close', isCancel, isStoredImage)
    },

    setImageLoading() {
      this.imageLoading = false
    },

    uploadImage(isStoredImage) {
      this.sendAsLink = false;
      this.$emit('upload', this.sendAsLink, isStoredImage)
    },

    uploadImageAsLink(isStoredImage) {
      !this.isBackup && (this.sendAsLink = true)
      this.$emit('upload', this.sendAsLink, isStoredImage)
    }
  },
  created() {
    this.sendAsLink = this.isLink
  },
}
</script>

<style lang="scss">
.scrollbar {
  ::-webkit-scrollbar {
    width: 14px;
  }

  ::-webkit-scrollbar-track {
    opacity: 0;
  }

  ::-webkit-scrollbar-thumb {
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: #AAAAAA;
  }


  .image-preview-container .filters-wrapper .filter-icon {
    color: #7c65f8;
    font-size: 20px;
    margin: auto 10px;
  }

  .image-preview-container .filters-wrapper li {
    color: #7c65f8;
    margin-left: 14px;
    text-align: left;
  }

  .image-preview-container .filters-wrapper li span {
    color: black;
    font-size: .9em;
  }

  .image-preview-container .setting-wrapper {
    margin-top: 10px;
  }
}

</style>
